/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { LEVEL_OF_DETAIL_TABLE_STRINGS } from '@appPlanApplication/lod/LevelOfDetail';

import { Side } from '@touchplan/common';
import { TicketType } from '@touchplan/common';

export enum TextComponents {
	activityNameComponent = 'activityNameComponent',
}

export enum SpecialLODConditions {
	isOneDayTicket = 'isOneDayTicket',
}

interface LodFontData {
	fontSize: number;
	lineHeight: string;
}

export type DefinitionTypes =
	| TextComponents
	| TicketType
	| Side
	| LEVEL_OF_DETAIL_TABLE_STRINGS
	| SpecialLODConditions;

//there must also be a value to fall back to
// if a level omits a value, that level will be assumed to have the value of it's parent
// It will attempt to grab the deepest nested value based on the keys provided.

const definitionTable = {
	[TicketType.Task]: {
		value: { fontSize: 32, lineHeight: '32px' },
		[TextComponents.activityNameComponent]: {
			value: { fontSize: 32, lineHeight: '36px' },
			[Side.ACTIVE]: {
				value: { fontSize: 42, lineHeight: '36px' },
				[LEVEL_OF_DETAIL_TABLE_STRINGS.MAXIMUM]: {
					value: { fontSize: 28, lineHeight: '28px' },
				},
				[LEVEL_OF_DETAIL_TABLE_STRINGS.VERY_HIGH]: {
					value: { fontSize: 32, lineHeight: '32px' },
				},
				[SpecialLODConditions.isOneDayTicket]: {
					value: { fontSize: 32, lineHeight: '32px' },
					[LEVEL_OF_DETAIL_TABLE_STRINGS.MAXIMUM]: {
						value: { fontSize: 24, lineHeight: '24px' },
					},
					[LEVEL_OF_DETAIL_TABLE_STRINGS.VERY_HIGH]: {
						value: { fontSize: 28, lineHeight: '28px' },
					},
				},
			},
		},
	},
	[TicketType.Constraint]: {
		value: { fontSize: 32, lineHeight: '32px' },
		[TextComponents.activityNameComponent]: {
			value: { fontSize: 32, lineHeight: '36px' },
			[Side.ACTIVE]: {
				value: { fontSize: 32, lineHeight: '32px' },
				[LEVEL_OF_DETAIL_TABLE_STRINGS.MAXIMUM]: {
					value: { fontSize: 24, lineHeight: '24px' },
				},
				[LEVEL_OF_DETAIL_TABLE_STRINGS.VERY_HIGH]: {
					value: { fontSize: 28, lineHeight: '28px' },
				},
			},
		},
	},
	[TicketType.Milestone]: {
		value: { fontSize: 32, lineHeight: '32px' },
		[TextComponents.activityNameComponent]: {
			value: { fontSize: 32, lineHeight: '36px' },
			[Side.ACTIVE]: {
				value: { fontSize: 32, lineHeight: '32px' },
				[LEVEL_OF_DETAIL_TABLE_STRINGS.MAXIMUM]: {
					value: { fontSize: 24, lineHeight: '24px' },
				},
				[LEVEL_OF_DETAIL_TABLE_STRINGS.VERY_HIGH]: {
					value: { fontSize: 28, lineHeight: '28px' },
				},
			},
		},
	},
};

export function getLodDefinition(keys: DefinitionTypes[]): LodFontData {
	let lastThing = definitionTable;
	let lastValue;

	for (let i = 0; i < keys.length; i++) {
		const key = keys[i];
		const thing = lastThing[key];
		if (thing) {
			lastThing = thing;
			if (thing.value) {
				lastValue = thing.value;
			}
		} else {
			break;
		}
	}
	return lastValue;
}

// MOC-3093
// window.ticketTextScale = 1;
// window.setTextScale = function(newScale: number){
// 	window.ticketTextScale = newScale;
// };
